module.exports = __webpack_public_path__ + "static/media/StarLoader.4cf81944.svg";